import { Directive, HostListener, ElementRef, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { parseMoneyInput } from '../helper/utils';

@Directive({
  selector: '[mask-money]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaskMoneyDirective),
      multi: true,
    },
  ],
})
export class MaskMoneyDirective implements ControlValueAccessor {
  @Input() prefix: string = 'R$ ';
  private onChange = (_: any) => {};
  private onTouched = () => {};
  private lastNumericValue: number | null = null;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    if (value == null || value === '') {
      this.el.nativeElement.value = '';
      this.lastNumericValue = null;
      return;
    }

    // Aceita number ou string, mas NUNCA emite para o model aqui.
    const numeric = this.toNumber(value);
    this.lastNumericValue = numeric;
    this.el.nativeElement.value = this.format(numeric);
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void { this.el.nativeElement.disabled = isDisabled; }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const numeric = parseMoneyInput(event.target.value);
    this.lastNumericValue = numeric;
    this.el.nativeElement.value = this.format(numeric);
    this.onChange(numeric); // model recebe SEMPRE number durante a digitação
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
    // Garante que o último valor enviado no blur também é number (caso algo tenha empurrado string)
    if (this.lastNumericValue != null) {
      // microtask: roda depois de qualquer outro listener de blur
      Promise.resolve().then(() => this.onChange(this.lastNumericValue!));
    }
  }

  @HostListener('change')
  onNativeChange() {
    // Alguns ambientes disparam 'change' no blur; reforça número como último evento
    if (this.lastNumericValue != null) {
      this.onChange(this.lastNumericValue!);
    }
  }

  private format(value: number): string {
    const [reais, centavos] = value.toFixed(2).split('.');
    return `${this.prefix}${Number(reais).toLocaleString('pt-BR')},${centavos}`;
  }

  private toNumber(value: unknown): number {
    if (typeof value === 'number' && isFinite(value)) return value;
    const digits = String(value ?? '').replace(/\D/g, '');
    const n = Number(digits);
    return isFinite(n) ? n / 100 : 0;
  }
}